var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.589 27.898V8.32h32.77v19.578H4.588Z","stroke":"#D22128","key":0}),React.createElement("path",{"d":"M21 39H9.953v-3.342H21M16.445 35.553v-4.23H1V5h20M21 39h11.047v-3.342H21M25.555 35.553v-4.23H41V5H21","stroke":"#D22128","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M11.89 11.006H7.335v4.544h4.555v-4.544ZM19.377 11.006h-4.555v4.544h4.555v-4.544ZM26.812 11.006h-4.555v4.544h4.555v-4.544ZM34.298 11.006h-4.555v4.544h4.555v-4.544ZM11.89 19.467H7.335v4.544h4.555v-4.544ZM19.377 19.467h-4.555v4.544h4.555v-4.544ZM26.812 19.467h-4.555v4.544h4.555v-4.544ZM34.298 19.467h-4.555v4.544h4.555v-4.544Z","fill":"#fff","stroke":"#D22128","strokeMiterlimit":"10","key":2})]);
}

Desktop.defaultProps = {"width":"42","height":"40","fill":"none"};

module.exports = Desktop;

Desktop.default = Desktop;
